import React from 'react';
import { AuthProvider } from './AuthContext';
import { NavigationProvider } from './NavigationContext';
import { ThemeProvider } from './ThemeContext';
import { DailyDecisionProvider } from './DailyDecisionContext';
import { PersistentWidgetProvider } from './PersistentWidgetContext';
import { CharacterPopupProvider } from './CharacterPopupContext';

/**
 * ContextContainer - Main context wrapper for the entire application
 * This component provides all necessary context providers to the app
 */
export function ContextContainer({ children }) {
  return (
      <AuthProvider>
        <NavigationProvider>
          <ThemeProvider>
            <CharacterPopupProvider>
              <DailyDecisionProvider>
                <PersistentWidgetProvider>
                  {children}
                </PersistentWidgetProvider>
              </DailyDecisionProvider>
            </CharacterPopupProvider>
          </ThemeProvider>
        </NavigationProvider>
      </AuthProvider>
  );
}

export default ContextContainer;
